import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isFalsy',
  standalone: true,
})
export class IsFalsyPipe implements PipeTransform {
  public transform(value: unknown): boolean {
    return !value;
  }
}
